import { ButtonBox, ButtonWrap, HelpText, Icon } from "@shared/src";
import styles from "./inputModal.module.scss";
import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { Error } from "@src/shared/src/components/icons/18";

interface IInputModalButton {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  theme?: string;
  size?: string;
  action: () => void;
}
interface IInputModal {
  inputPlaceholder: string;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  modalId?: string;
  isShow: boolean;
  title?: string;
  errorText?: string;
  overlay?: boolean;
  overlayValue?: number;
  overlayStyle?: React.CSSProperties;
  theme?: "brown500";
  text?: string;
  buttons?: IInputModalButton[];
  onClose?: () => void;
}
const InputModal = ({
  inputPlaceholder,
  inputValue,
  setInputValue,
  modalId,
  isShow,
  overlay = false,
  overlayValue = 0.08,
  overlayStyle,
  theme,
  title,
  errorText = "",
  text,
  buttons,
  onClose,
}: IInputModal) => {
  const uuid = uuidv4();
  return (
    <div className={styles["modal-wrap"]} style={{ display: isShow ? "block" : "none" }}>
      {overlay && (
        <div
          className={styles["modal-overlay"]}
          style={{
            backgroundColor: `rgba(0, 0, 0, ${overlayValue})`,
            ...overlayStyle,
          }}
        ></div>
      )}
      <div className={styles["modal"]}>
        <div
          className={`${styles["modal-content-box"]} ${title && text ? styles["exists-title-and-text"] : ""}`}
        >
          <h2 className={styles["modal-title"]}>{title}</h2>
          <p className={styles["modal-text"]}>{text}</p>
          <input
            type="text"
            placeholder={inputPlaceholder}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className={styles["modal-input"]}
          />
          {errorText && (
            <div className={styles["modal-error-text-wrap"]}>
              <Icon size={18} IconComponent={<Error />} />
              <p className={styles["error-text"]}>{errorText}</p>
            </div>
          )}
        </div>

        {buttons ? (
          <ButtonWrap
            firstRatio={buttons.length >= 2 ? 1 : null}
            noPaddingPosition="all"
            className={`${styles["modal-btn-wrap"]}`}
          >
            {buttons.map((button) => (
              <ButtonBox
                key={`${modalId ? modalId : uuid}-${button.name}`}
                text={button.name}
                style={button.style ? button.style : {}}
                size={button.size ? button.size : "giant"}
                theme={button.theme ? button.theme : "red500"}
                fullWidth={buttons.length === 1}
                className={`${button?.className ? button.className : ""}`}
                onClick={() => button.action()}
              />
            ))}
          </ButtonWrap>
        ) : (
          <ButtonWrap noPaddingPosition="all" className={`${styles["modal-btn-wrap"]}`}>
            <ButtonBox
              text="확인"
              size="giant"
              theme={theme ? theme : "red500"}
              fullWidth
              onClick={onClose}
            />
          </ButtonWrap>
        )}
      </div>
    </div>
  );
};

export default InputModal;
